export const language = navigator.languages
	? navigator.languages[0]
	: navigator.language || navigator.userLanguage;



// WEBPACK FOOTER //
// ./src/DeviceDetection.js